<!-- 活动资源位 item -->
<template>
  <img :src="imageUrl" alt="activity" @click="handleClick" />
</template>

<script>
import handleRedirect from '../mixins/pureHandleRedirect';

export default {
  props: {
    imageUrl: {
      type: String,
      required: true
    }
  },
  mixins: [handleRedirect],
  methods: {
    handleClick() {
      this.handleRedirect();
    }
  }
};
</script>
